import { subscriptionPlanSchema, walletTopupConfigSchema, walletTopupQuoteSchema } from '../schemas/credit';
const PLAN_DATA = subscriptionPlanSchema.array().parse([
    {
        id: 'free',
        name: 'Free',
        description: '',
        monthlyCredits: 600,
        rolloverLimit: 0,
        rolloverPolicy: 'limited',
        priceHalalas: 0,
        currency: 'SAR',
        billingInterval: 'monthly',
        seatLimit: 1,
        queuePriority: 'standard',
        supportLevel: 'community',
        features: ['600 points per month', 'Points do not renew automatically'],
        isDefault: true
    },
    {
        id: 'creator',
        name: 'Creator',
        description: '',
        monthlyCredits: 3600,
        rolloverLimit: 3600,
        rolloverPolicy: 'reset_monthly',
        priceHalalas: 14900,
        currency: 'SAR',
        billingInterval: 'monthly',
        seatLimit: 1,
        queuePriority: 'standard',
        supportLevel: 'community',
        features: ['3,600 credits per month', 'Credits refresh each renewal'],
        isDefault: false
    },
    {
        id: 'studio',
        name: 'Studio',
        description: '',
        monthlyCredits: 9000,
        rolloverLimit: 9000,
        rolloverPolicy: 'reset_monthly',
        priceHalalas: 32900,
        currency: 'SAR',
        billingInterval: 'monthly',
        seatLimit: 3,
        queuePriority: 'priority',
        supportLevel: 'email',
        features: ['9,000 credits per month', 'Credits refresh each renewal'],
        isDefault: false
    },
    {
        id: 'pro',
        name: 'Pro',
        description: '',
        monthlyCredits: 22000,
        rolloverLimit: 22000,
        rolloverPolicy: 'reset_monthly',
        priceHalalas: 69900,
        currency: 'SAR',
        billingInterval: 'monthly',
        seatLimit: 5,
        queuePriority: 'express',
        supportLevel: 'priority',
        features: ['22,000 credits per month', 'Credits refresh each renewal'],
        isDefault: false
    }
]);
// 27 credits/SAR keeps top-up quotes human-friendly.
// Assistant and model markup are controlled separately in their pricing configs.
const WALLET_TOPUP_DATA = walletTopupConfigSchema.parse({
    currency: 'SAR',
    minAmountHalalas: 1000,
    maxAmountHalalas: 500000,
    suggestedAmountsHalalas: [1000, 5000, 10000, 25000],
    creditsPerSar: 27,
    expiresAfterDays: 36500
});
const LEGACY_CREDIT_PACK_AMOUNT_BY_ID = {
    'topup-2000': 11900,
    'topup-6000': 29900,
    'topup-15000': 69900
};
export const SUBSCRIPTION_PLANS = PLAN_DATA;
export const WALLET_TOPUP_CONFIG = WALLET_TOPUP_DATA;
export const listSubscriptionPlans = () => [...SUBSCRIPTION_PLANS];
export const getSubscriptionPlanById = (id) => SUBSCRIPTION_PLANS.find((plan) => plan.id === id);
export const getDefaultSubscriptionPlan = () => SUBSCRIPTION_PLANS.find((plan) => plan.isDefault);
export const getWalletTopupConfig = () => ({
    ...WALLET_TOPUP_CONFIG,
    suggestedAmountsHalalas: [...WALLET_TOPUP_CONFIG.suggestedAmountsHalalas]
});
export const isWalletTopupAmountHalalasAllowed = (amountHalalas) => {
    if (!Number.isInteger(amountHalalas)) {
        return false;
    }
    return (amountHalalas >= WALLET_TOPUP_CONFIG.minAmountHalalas &&
        amountHalalas <= WALLET_TOPUP_CONFIG.maxAmountHalalas &&
        amountHalalas % 100 === 0);
};
export const quoteWalletTopup = (amountHalalas) => {
    const credits = Math.round((amountHalalas / 100) * WALLET_TOPUP_CONFIG.creditsPerSar);
    return walletTopupQuoteSchema.parse({
        amountHalalas,
        currency: WALLET_TOPUP_CONFIG.currency,
        credits,
        expiresAfterDays: WALLET_TOPUP_CONFIG.expiresAfterDays
    });
};
export const getLegacyWalletTopupAmountHalalas = (packId) => LEGACY_CREDIT_PACK_AMOUNT_BY_ID[packId];
//# sourceMappingURL=billing.js.map
